<template>
  <v-container>
    <div>
      <div style="text-align:center;" class="mic_container">
        <v-container>
          <v-layout row>
            <v-flex xs6 offset-xs3>
              <v-btn block style="height:75px; border: 2px solid #5ca322; border-radius: 10px; text-transform: none !important;">
                <img :src="require('@/assets/logo_only.png')" alt="Herz" width="60" class="hidden-sm-and-down" style="margin-right: 20px;">
                <span v-bind:style="{ fontSize: fontSizeH1 }" style="fletter-spacing:3px; color: dimgrey;white-space: normal;">Herzlich Willkommen</span>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12>
              <h2 v-bind:style="{ fontSize: fontSizeH2 }" style="margin-top: 50px; color: dimgrey;">Zu deiner persönlichen</h2>
              <h1 v-bind:style="{ fontSize: fontSizeH1 }" style="color: dimgrey;">Ernährungs- und Kursumgebung</h1>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs8 offset-xs2 style="margin-top: 50px"  @click="redirect('/tracking/overview')" class="pointer hidden-md-and-up">
              <h3 style="font-size: 18px; color: dimgrey;">Zu deinen Verlaufsdaten</h3>
              <div class="box_small" style="margin-top: 5px">
                <div class="image_container_small">
                  <img
                    :src="require('@/assets/tracking.png')" alt="Motivation" width="50" style="align-content:center; margin-top: 20px;"
                  >
                </div>
              </div>
              <p style="margin-top: 15px; font-size: 16px; color: dimgrey;">Dokumentiere deinen Fortschritt <br/> und lass dir deine Erfolge anzeigen!</p>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs8 offset-xs2 style="margin-top: 50px" @click="redirect('/motivation')" class="pointer hidden-md-and-up">
              <h3 style="font-size: 18px; color: dimgrey;">Zur Motivation</h3>
              <div class="box_small" style="margin-top: 5px">
                <div class="image_container_small">
                  <img
                    :src="require('@/assets/motivation.png')" alt="Motivation" width="50" style="align-content:center; margin-top: 20px"
                  >
                </div>
              </div>
              <p style="margin-top: 15px; font-size: 16px; color: dimgrey;">Was motiviert dich? <br/> Wie können wir helfen dein Ziel zu erreichen?</p>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs8 offset-xs2 style="margin-top: 50px" @click="redirect('/course/1')" class="pointer hidden-md-and-up">
              <h3 style="font-size: 18px; color: dimgrey;">Zu deiner Kurseinheit</h3>
              <div class="box_small" style="margin-top: 5px">
                <div class="image_container_small">
                  <img
                    :src="require('@/assets/training.png')" alt="Motivation" width="50" style="align-content:center; margin-top: 20px"
                  >
                </div>
              </div>
              <p style="margin-top: 15px; font-size: 16px; color: dimgrey;">Zur ersten Kurseinheit mit Rezepten. <br/> Die folgenden Kurseinheiten findest du oben in der Navigationsleiste.</p>
            </v-flex>
          </v-layout>
          <v-layout style="margin-top: 50px;" class="hidden-sm-and-down">
            <v-flex xs12 sm6 md4>
              <h3 @click="redirect('/tracking/overview')" class="pointer" style="font-size: 18px; color: dimgrey;">Zu deinen Verlaufsdaten</h3>
              <v-layout justify-center style="margin-top: 15px;">
                <div class="image_container pointer" @click="redirect('/tracking/overview')">
                  <img
                    :src="require('@/assets/tracking.png')" alt="Motivation" width="100" style="align-content:center; margin-top: 40px;"
                  >
                </div>
              </v-layout>
              <p @click="redirect('/tracking/overview')" class="pointer" style="margin-top: 15px; font-size: 16px; color: dimgrey;">Dokumentiere deinen Fortschritt <br/> und lass dir deine Erfolge anzeigen!</p>
            </v-flex>
            <v-flex  xs12 sm6 md4>
              <h3 @click="redirect('/motivation')" class="pointer" style="font-size: 18px; color: dimgrey;">Zur Motivation</h3>
              <v-layout justify-center style="margin-top: 15px;">
                <div class="image_container pointer" @click="redirect('/motivation')">
                  <img
                    :src="require('@/assets/motivation.png')" alt="Motivation" width="100" style="align-content:center; margin-top: 40px"
                  >
                </div>
              </v-layout>
              <p @click="redirect('/motivation')" class="pointer"  style="margin-top: 15px; font-size: 16px; color: dimgrey;">Was motiviert dich? <br/> Wie können wir helfen dein Ziel zu erreichen?</p>
            </v-flex>
            <v-flex  xs12 sm6 md4>
              <h3 @click="redirect('/course/1')" class="pointer" style="font-size: 18px; color: dimgrey;">Zu deiner Kurseinehit</h3>
              <v-layout justify-center style="margin-top: 15px;">
                <div class="image_container pointer" @click="redirect('/course/1')">
                  <img
                    :src="require('@/assets/training.png')" alt="Motivation" width="100" style="align-content:center; margin-top: 40px;"
                  >
                </div>
              </v-layout>
              <p @click="redirect('/course/1')" class="pointer" style="margin-top: 15px; font-size: 16px; color: dimgrey;">Zur ersten Kurseinehit mit Rezepten. <br/>Die folgenden Kurseinheiten findest du oben in der Navigationsleiste.</p>
            </v-flex>
          </v-layout>
          <v-layout xs12 row>
            <v-flex xs6 offset-xs3 class="hidden-sm-and-down">
              <v-btn class="speech-bubble" tile outlined large style="height: 100px; padding:5px; margin-top: 50px!important; margin-bottom:50px!important; border: 2px solid #5ca322; border-radius: 25px; text-transform: none!important;">
                <a v-bind:style="{ fontSize: fontSizeH3 }" href="https://mindcarb.de/#anchor-contact" target="_blank" style="padding: 5px;color: gray">Hast du Fragen zu deiner Kurseinheit? <br/> Unser Expertenteam beantwortet sie dir gerne!</a>
              </v-btn>
            </v-flex>
            <v-flex xs10 offset-xs1 class="hidden-md-and-up">
              <v-btn class="speech-bubble" tile outlined large style="height: 50px; padding:5px; margin-top: 25px!important; margin-bottom:25px!important; border: 2px solid #5ca322; border-radius: 25px; text-transform: none!important;">
                <a v-bind:style="{ fontSize: fontSizeH3 }" href="https://mindcarb.de/#anchor-contact" target="_blank" style="padding: 5px; color: gray">Hast du Fragen zu deiner Kurseinheit? <br/> Unser Expertenteam beantwortet sie dir gerne!</a>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      disabled: false,
      headline: '-lich Willkommen',
      introductionInfo: 'Zu deiner persönlichen Ernährungs- und Kursumgebung',
      trackingHeadline: 'Zu deinen Verlaufsdaten',
      motivationHeadline: 'Zum Motivationsfragebogen',
      trainingHeadline: 'Zu deinen Kursen'

    }
  },
  computed: {
    fontSizeH1 () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '20px'
        case 'sm': return '20px'
        case 'md': return '28px'
        case 'lg': return '36px'
        case 'xl': return '36px'
      }
    },
    fontSizeH2 () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '16px'
        case 'sm': return '16px'
        case 'md': return '20px'
        case 'lg': return '28px'
        case 'xl': return '28px'
      }
    },
    fontSizeH3 () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '10px'
        case 'sm': return '10px'
        case 'md': return '18px'
        case 'lg': return '20px'
        case 'xl': return '20px'
      }
    }
  },
  methods: {
    redirect (redirect) {
      this.$router.push(redirect)
    }
  }
}
</script>

<style scoped="true">
  .image_container {
    border-radius: 50%;
    background-color: #FFFFFF;
    padding: 5px;
    width: 200px;
    height: 200px
  }

  .image_container_small {
    border-radius: 50%;
    background-color: #FFFFFF;
    padding: 5px;
    width: 100px;
    height: 100px
  }

  .box {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .box_small {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .box div {
    width: 200px;
    height: 200px;
  }
  .speech-bubble {
    position: relative;
    background: white;
    border-radius: .4em;
  }

  .pointer {
    cursor: pointer;
  }

  .speech-bubble:after {
    content: '';
    position: absolute;
    bottom: 0;
    right: 4%;
    width: 0;
    height: 0;
    border: 31px solid transparent;
    border-top-color: #5ca322;
    border-bottom: 0;
    border-right: 0;
    margin-left: -15.5px;
    margin-bottom: -31px;
  }

  #rounded-card {
    border-radius: 50%;
    min-height: 200px;
    min-width: 200px;
    padding: 25px;
  }

</style>



// WEBPACK FOOTER //
// src/welcome/WelcomePage.vue